export const AppConfig = {
    productsWithTiles: new Set([
      'researchcompanion', 'elibrary', 'sirsdiscoverer',
      'sirsissuesresearcher', 'hsc', 'pqll', 'drap2',
      'musicdanceaca', 'pbs4', 'avc', 'radr', 'radr2', 'glmu2'
    ])
  };